<template>
  <div class="progress-bar" />
</template>

<script lang="ts" setup>
interface Props {
  value: number; // 0-100
  color?: string;
  backgroundColor?: string;
}

withDefaults(defineProps<Props>(), {
  color: 'var(--color-info-blue-100)',
  backgroundColor: 'rgba(var(--color-info-blue-100-rgb), 0.5)',
});
</script>

<style lang="scss" scoped>
.progress-bar {
  @apply rounded-4 h-4 w-full overflow-hidden;

  --color: v-bind("color");
  --bg-color: v-bind("backgroundColor");
  --bar-length: v-bind("`${value}%`");

  background-color: var(--bg-color);

  @include absolutePseudo("before") {
    @apply h-full top-0 left-0;
    @apply rounded-4;

    width: var(--bar-length);
    background-color: var(--color);
    transition: width var(--speed-fast) ease;
  }
}
</style>
